export function backendToFrontendFilter(filterType) {
  let urlFriendlyFilterType = filterType;
  switch (filterType) {
    case 'resourceType':
      urlFriendlyFilterType = 'contentType';
      break;
    default:
      break;
  }
  return urlFriendlyFilterType;
}
